export const getFiltersArray = <T>(filtersByArea: ArrayLike<unknown>): T => {
  const handledFiltersByArea = [];
  const entriesFromFiltersByArea = Object.entries(filtersByArea);

  for (const [key, val] of entriesFromFiltersByArea) {
    handledFiltersByArea[+key] = val;
  }

  return handledFiltersByArea as T;
};
